import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React from 'react';
import { withTranslation } from 'react-i18next';

import commonStyles from '../../Common/commonStyles';

const styles = StyleSheet.create({
  elements: {
    ...commonStyles.fontM,
    marginHorizontal: commonStyles.marginHorizontal,
    paddingBottom: '2%',
    borderBottom: '1.5px solid #b8b8b8',
    marginBottom: '2%',
  },
  title: {
    fontWeight: 'bold',
  },
  titleRow: {
    ...commonStyles.flexRow,
    marginBottom: '2%',
  },
  mainColumn: {
    width: '30%',
  },
  sizeColumn: {
    flex: 1,
  },
  sizeRow: {
    ...commonStyles.flexRow,
    marginBottom: '1%',
  },
  sizeCell: {
    fontWeight: 'bold',
  },
});

function DimensionsPage({ elements, sizes, t }) {
  return (
    <View style={styles.elements}>
      <View style={styles.titleRow}>
        <View style={styles.mainColumn}>
          <Text style={styles.title}>{t('product_dimensions')}</Text>
        </View>
        {sizes
          .filter((s) => s.isActive)
          .map((size) => (
            <View key={size.id} style={styles.sizeColumn}>
              <Text>{size.name}</Text>
            </View>
          ))}
        {/* Empty column for alignment with variants */}
        <View style={styles.sizeColumn} />
      </View>
      {elements.map((element) => (
        <View key={element.id} style={styles.sizeRow}>
          <View style={styles.mainColumn}>
            <Text>{element.name}</Text>
          </View>
          {element?.elementSizes?.map(
            (elementSize, esIdx) =>
              elementSize &&
              sizes.find((size) => size.id === elementSize.modelSpecificationSize?.id)
                ?.isActive && (
                <View key={elementSize.id ?? esIdx} style={styles.sizeColumn}>
                  <Text style={styles.sizeCell}>{elementSize.dimension}</Text>
                </View>
              ),
          )}
          {/* Empty column for alignment with variants */}
          <View style={styles.sizeColumn} />
        </View>
      ))}
    </View>
  );
}

export default withTranslation('specification')(DimensionsPage);
